window.versionControl = {
  core: {
    version: "v0.1.18w",
  },
};
